import { render, staticRenderFns } from "./tagsTable.vue?vue&type=template&id=3c860dd8"
import script from "./tagsTable.vue?vue&type=script&lang=js"
export * from "./tagsTable.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports